/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { format, add } from "date-fns";

const defaultGoTrackFilters = {
  searchTerm: null,
  routeType: 2,
  carrierId: null,
  districtId: null,
  regionId: null,
  facilityId: null,
  facilityName: null,
  facilitySlic: null,
  facilityAlpha: null,
  serviceLevel: null,
  sortType: null,
  sortColumn: null,
  sortDirection: null,
  alertsOnly: false,
  startDate: format(add(new Date(),{days:-2}), "MM/dd/yyyy"),
  endDate: format(add(new Date(),{days:2}), "MM/dd/yyyy"),
  currentPage: 0,
};

export default defaultGoTrackFilters;
